import { translate } from "../../Translations/translatorService";
import { SelectOption } from "../../../types/SelectOption";
import { FormElementPropsWithoutProduct } from "../../../components/Case/CaseForm/FormElement";
import { ProductUnion } from "../../../types/ProductUnion";

export const trueFalseDefaultOptions = (path: string) => {
  const options: SelectOption[] = [
    { value: "__null__", disabled: true, label: translate(`${path}.values.__null__`, " ") },
    // @ts-ignore
    { value: true, label: translate(`${path}.values.true`, "Ja") },
    // @ts-ignore
    { value: false, label: translate(`${path}.values.false`, "Nein") },
  ];
  return options;
};

export const trueFalseNullDefaultOptions = (path: string) => {
  return [
    { value: null, label: translate(`${path}.values.__null__`, "-") },
    { value: true, label: translate(`${path}.values.true`, "Ja") },
    { value: false, label: translate(`${path}.values.false`, "Nein") },
  ];
};

export const yesNoDefaultOptions = (path: string) => {
  return [
    { value: "__null__", disabled: true, label: translate(`${path}.values.__null__`, " ") },
    { value: "yes", label: translate(`${path}.values.yes`, "Ja") },
    { value: "no", label: translate(`${path}.values.no`, "Nein") },
  ];
};

export const yesNoUnknownDefaultOptions = (path: string) => {
  return [
    { value: "__null__", disabled: true, label: translate(`${path}.values.__null__`, " ") },
    { value: "yes", label: translate(`${path}.values.yes`, "Ja") },
    { value: "no", label: translate(`${path}.values.no`, "Nein") },
    { value: "unknown", label: translate(`${path}.values.unknown`, "Nicht sicher") },
  ];
};

export function overwriteFormElementField<T extends ProductUnion = ProductUnion>(
  formElement: FormElementPropsWithoutProduct<T>[],
  path: FormElementPropsWithoutProduct<T>["path"],
  updates: Partial<FormElementPropsWithoutProduct<T>>
) {
  const field = formElement.find((f) => f.path === path);
  if (field) {
    Object.assign(field, updates);
  }

  return formElement;
}
